import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { TramiteSuperfinancieraDto } from '../../../../dto/tramites/tramite-superfinanciera.dto';
import { AnexoPrecargaResponseDto } from '../../../../dto/anexo/anexo-tramite.dto';
import { ArchivosFormDTO } from '../../../../dto/expediente/archivos-form.dto';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FormField, FormFieldOption } from '../../../../dto/util/form-field';
import { PersonaLoginDTO } from '../../../../dto/util/persona.dto';
import { PersonaDto } from '../../../../dto/tramites/persona.dto';
import { PaisDto } from '../../../../dto/expediente/pais.dto';
import { Constants } from '../../../../constants/constants';
import { TipoAnexoTipoTramiteDto } from '../../../util/archivos-tramite/dto/tipo-anexo-tipo-tramite.dto';
import { TableColumn } from '../../../../dto/util/table-column';
import { TableAction } from '../../../../dto/util/table-action';
import { ConfigurarCuentasService } from '../../../configuracion-cuenta/services/configurar-cuentas.service';
import { AlertaModalService } from '../../../../services/util/alerta-modal.service';
import { TranslateService } from '@ngx-translate/core';
import { ListasService } from '../../../../services/listas.service';
import { TextTransformService } from '../../../util/text-transform/text-transform.service';
import { TramiteDTO } from '../../models/tramiteDTO';
import { TramiteService } from '../../../../services/tramite.service';
import { combineLatest } from 'rxjs';

@Component({
  selector: 'app-sfc-demandante',
  templateUrl: './sfc-demandante.component.html',
  styleUrl: './sfc-demandante.component.scss'
})
export class SfcDemandanteComponent implements OnInit, OnChanges {
  @Input() tramiteSfc?: TramiteSuperfinancieraDto;
  @Input() archivosPreCargados?: AnexoPrecargaResponseDto[];
  archivoPrecargadoPoderJudicial?: AnexoPrecargaResponseDto;
  @Output() continuar = new EventEmitter<{
    tramite: TramiteSuperfinancieraDto;
    formValid: boolean;
    event: Event;
    anexos?: AnexoPrecargaResponseDto[];
  }>();
  @Output() guardarSinEnviar = new EventEmitter<{
    tramite: TramiteSuperfinancieraDto;
    formValid: boolean;
    event: Event;
    anexos?: AnexoPrecargaResponseDto[];
  }>();
  @Input() volver: boolean = false;
  @Output() demandanteEmit = new EventEmitter<{
    formTipoPersonaDemandante: FormGroup;
    formDemandante: FormGroup;
  }>();

  // Multilenguaje
  sfcText: any = {};
  comunText: any = {};
  alertaText: any = {};

  formFieldsTipoPersona: FormField[] = [];

  formFieldsDemandanteNatural: FormField[] = [];
  formFieldsDemandanteJuridica: FormField[] = [];

  mostrarFormulario = true;
  tipoPersona?: number;
  tipoDocumento?: number = 0;
  dataUsuario!: PersonaLoginDTO;
  demandantes: PersonaDto[] = [];
  demandados: PersonaDto[] = [];
  apoderado: PersonaDto[] = [];
  formTipoPersona!: FormGroup;
  formDemandante!: FormGroup;

  paises: PaisDto[] = [];

  public entidadId: number = Constants.ID_ENTIDAD_SUPERFINANCIERA;

  private prevTipo: number | null = null;
  private prevIdentificacion: string | null = null;
  // seteo inputs otro Departamento y municipio
  auxIdCountry: number[] = [];

  tipoAnexoPoderJudicial!: TipoAnexoTipoTramiteDto;

  anexoPoderJudicial: ArchivosFormDTO | null = null;

  // Tablas
  columnsNatural: TableColumn[] = [];
  columnsJuridica: TableColumn[] = [];
  actions: TableAction[] = [];
  dataTableNatural: PersonaDto[] = [];
  dataTableJuridica: PersonaDto[] = [];
  indexEditarDemandante: number | undefined = undefined;

  // Listas
  listasSexo: FormFieldOption[] = [];
  demandanteOriginal: PersonaDto | null = null;
  isEdit: boolean = false;

  existePersona: boolean = false;

  buildForms() {
    this.formFieldsTipoPersona = [
      {
        name: 'tipoPersona',
        label: this.comunText['tipo-demandante'],
        type: 'select',
        required: true,
        options: [
          { Id: '1', Nombre: this.comunText['persona-natural-select'] },
          { Id: '2', Nombre: this.comunText['persona-juridica-select'] },
        ],
        width: '12',
        visible: true,
        errorMessages: { required: this.comunText['tipo-persona-required'] },
      },
    ];

    this.formFieldsDemandanteNatural = [
      {
        name: 'typeOfDocument',
        label: this.comunText['tipo-documento'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        personTypeId: '1',
        visible: true,
        errorMessages: { required: this.comunText['tipo-documento-required'] },
      },
      {
        name: 'identificacion',
        label: this.comunText['numero-documento'],
        type: 'text',
        required: true,
        placeholder: this.comunText['numero-documento-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(4),
          Validators.pattern(Constants.REGEX_TELEFONO),
        ],
        errorMessages: {
          required: this.comunText['numero-documento-required'],
        },
      },
      {
        name: 'primerNombre',
        label: this.comunText['primer-nombre'],
        type: 'text',
        required: true,
        placeholder: this.comunText['primer-nombre-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          required: this.comunText['primer-nombre-required'],
          pattern: this.comunText['nombre-pattern'],
          minlength: this.comunText['nombre-minlength'],
          maxlength: this.comunText['nombre-maxlength'],
        },
      },
      {
        name: 'segundoNombre',
        label: this.comunText['segundo-nombre'],
        type: 'text',
        required: false,
        placeholder: this.comunText['segundo-nombre-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          pattern: this.comunText['nombre-pattern'],
          minlength: this.comunText['nombre-minlength'],
          maxlength: this.comunText['nombre-maxlength'],
        },
      },
      {
        name: 'primerApellido',
        label: this.comunText['primer-apellido'],
        type: 'text',
        required: true,
        placeholder: this.comunText['primer-apellido-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          required: this.comunText['primer-apellido-required'],
          pattern: this.comunText['nombre-pattern'],
          minlength: this.comunText['apellido-minlength'],
          maxlength: this.comunText['apellido-maxlength'],
        },
      },
      {
        name: 'segundoApellido',
        label: this.comunText['segundo-apellido'],
        type: 'text',
        required: false,
        placeholder: this.comunText['segundo-apellido-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          pattern: this.comunText['nombre-pattern'],
          minlength: this.comunText['apellido-minlength'],
          maxlength: this.comunText['apellido-maxlength'],
        },
      },
      {
        name: 'fechaNacimiento',
        label: this.comunText['fecha-nacimiento'],
        type: 'date',
        placeholder: 'Ingrese su fecha de nacimiento',
        width: '6',
        visible: true,
        errorMessages: {
          edadRequerida: `${this.comunText['fecha-nacimiento-edad-requerida']} ${Constants.ANIOS_REQUERIDOS} ${this.comunText['fecha-nacimiento-anio']}.`,
        },
      },
      {
        name: 'telefono',
        label: this.sfcText['sfc-procon']['numero-celular'],
        type: 'text',
        required: true,
        placeholder: this.sfcText['sfc-procon']['numero-celular-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(6),
          Validators.maxLength(15),
          Validators.pattern(Constants.REGEX_TELEFONO),
        ],
        errorMessages: {
          required: this.sfcText['sfc-procon']['numero-celular-required'],
          minlength: this.sfcText['sfc-procon']['numero-celular-minlength'],
          maxlength: this.sfcText['sfc-procon']['numero-celular-maxlength'],
          pattern: this.sfcText['sfc-procon']['numero-celular-pattern'],
        },
      },
      {
        name: 'email',
        label: this.comunText['email'],
        type: 'email',
        required: true,
        placeholder: this.comunText['email-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.pattern(Constants.REGEX_CORREO_ELECTRONICO),
          Validators.maxLength(100),
        ],
        errorMessages: {
          required: this.comunText['correo-required'],
          pattern: this.comunText['email-pattern'],
          maxlength: this.comunText['email-maxlength'],
        },
      },
      {
        name: 'country',
        label: this.comunText['country'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        value: 1,
        disabled: false,
        errorMessages: { required: this.comunText['country-required'] },
      },
      {
        name: 'departament',
        label: this.comunText['departament'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        errorMessages: { required: this.comunText['departament-required'] },
      },
      {
        name: 'municipality',
        label: this.comunText['municipality'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        errorMessages: { required: this.comunText['municipality-required'] },
      },
      {
        name: 'otroDepartamento',
        label: this.comunText['departament'],
        placeholder: '',
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS),
          Validators.maxLength(30)
        ],
        errorMessages: {
          required: this.comunText['departament-required'],
          maxlength: this.sfcText['tramite-sic-procon']['campo-maxlength'],
          pattern: this.comunText['department-pattern']
        },
        dependsOn: 'country',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined || value === null) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        },
        tooltip: this.sfcText['tramite-sic-procon']['escriba-departamento'],
      },
      {
        name: 'otroMunicipio',
        label: this.comunText['municipality'],
        placeholder: '',
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS),
          Validators.maxLength(30)
        ],
        errorMessages: {
          required: this.sfcText['tramite-sic-procon']['campo-required'],
          maxlength: this.sfcText['tramite-sic-procon']['campo-maxlength'],
          pattern: this.comunText['municipality-pattern']
        },
        dependsOn: 'country',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined || value === null) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        },
        tooltip: this.sfcText['tramite-sic-procon']['escriba-municipio'],
      },
      {
        name: 'direccion',
        label: this.comunText['direccion-notificacion-judicial'],
        type: 'text',
        required: true,
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(10),
          Validators.maxLength(40),
          Validators.pattern(
            Constants.REGEX_ALPHANUMERIC_WITHOUT_SPACES_ADDRESS
          ),
        ],
        maxLength: '40',
        errorMessages: {
          required: this.comunText['direccion-notificacion-judicial-required'],
          minlength:
            this.comunText['direccion-notificacion-judicial-minlength'],
          maxlength:
            this.comunText['direccion-notificacion-judicial-maxlength'],
          pattern: this.comunText['direccion-notificacion-judicial-pattern'],
        },
      },
      {
        name: 'sexo',
        label: this.sfcText['sfc-procon']['genero'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        errorMessages: {
          required: this.sfcText['sfc-procon']['genero-required'],
        },
      },
      {
        name: 'lgtbiq',
        label: this.sfcText['sfc-procon']['lgtbiq'],
        type: 'radio',
        required: true,
        options: [
          { Nombre: this.comunText['opcion-si'], Id: 1 },
          { Nombre: this.comunText['opcion-no'], Id: 2 },
        ],
        width: '6',
        visible: true,
        errorMessages: {
          required: this.sfcText['sfc-procon']['campo-requerido'],
        },
        value: 2,
      },
      {
        name: 'conditionEspecial',
        label: this.sfcText['sfc-procon']['condition-especial'],
        type: 'radio',
        required: true,
        options: [
          { Nombre: this.comunText['opcion-si'], Id: 1 },
          { Nombre: this.comunText['opcion-no'], Id: 2 },
        ],
        width: '6',
        visible: true,
        errorMessages: {
          required: this.sfcText['sfc-procon']['campo-requerido'],
        },
        value: 2,
      }
    ];

    this.formFieldsDemandanteJuridica = [
      {
        name: 'typeOfDocument',
        label: this.comunText['tipo-documento'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        personTypeId: '2',
        errorMessages: { required: this.comunText['tipo-documento-required'] },
      },
      {
        name: 'identificacion',
        label: this.comunText['nit'],
        type: 'text',
        required: true,
        placeholder: this.comunText['numero-documento-placeholder'],
        width: '6',
        visible: true,
        validation: [Validators.maxLength(9)],
        errorMessages: {
          required: this.comunText['numero-documento-required'],
          maxlength: this.sfcText['tramite-sic-procon']['nit-maxlength'],
          pattern:
            this.sfcText['tramite-sic-procon']['identificacion-pattern'],
        },
      },
      {
        name: 'razonSocial',
        label: this.comunText['razon-social'],
        type: 'text',
        required: true,
        placeholder: this.comunText['razon-social-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(3),
          Validators.maxLength(100),
          Validators.pattern(Constants.REGEX_ALPHANUMERIC_RAZON_SOCIAL),
        ],
        errorMessages: {
          required: this.comunText['razon-social-required'],
          minlength: this.comunText['razon-social-minlength'],
          maxlength: this.comunText['razon-social-maxlength'],
          pattern: this.comunText['razon-social-pattern'],
        },
      },
      {
        name: 'direccion',
        label: this.comunText['direccion-notificacion-judicial'],
        type: 'text',
        required: true,
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(10),
          Validators.maxLength(40),
          Validators.pattern(
            Constants.REGEX_ALPHANUMERIC_WITHOUT_SPACES_ADDRESS
          ),
        ],
        maxLength: '40',
        errorMessages: {
          required: this.comunText['direccion-notificacion-judicial-required'],
          minlength:
            this.comunText['direccion-notificacion-judicial-minlength'],
          maxlength:
            this.comunText['direccion-notificacion-judicial-maxlength'],
          pattern: this.comunText['direccion-notificacion-judicial-pattern'],
        },
      },
      {
        name: 'telefono',
        label: this.sfcText['sfc-procon']['numero-celular'],
        type: 'text',
        required: true,
        placeholder: this.sfcText['sfc-procon']['numero-celular-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(6),
          Validators.maxLength(15),
          Validators.pattern(Constants.REGEX_TELEFONO),
        ],
        errorMessages: {
          required: this.sfcText['sfc-procon']['numero-celular-required'],
          minlength: this.sfcText['sfc-procon']['numero-celular-minlength'],
          maxlength: this.sfcText['sfc-procon']['numero-celular-maxlength'],
          pattern: this.sfcText['sfc-procon']['numero-celular-pattern'],
        },
      },
      {
        name: 'country',
        label: this.comunText['country'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        value: 1,
        disabled: false,
        errorMessages: { required: this.comunText['country-required'] },
      },
      {
        name: 'departament',
        label: this.comunText['departament'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        errorMessages: { required: this.comunText['departament-required'] },
      },
      {
        name: 'municipality',
        label: this.comunText['municipality'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        errorMessages: { required: this.comunText['municipality-required'] },
      },
      {
        name: 'otroDepartamento',
        label: this.comunText['departament'],
        placeholder: '',
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS),
          Validators.maxLength(30)
        ],
        errorMessages: {
          required: this.comunText['departament-required'],
          maxlength: this.sfcText['tramite-sic-procon']['campo-maxlength'],
          pattern: this.comunText['department-pattern']
        },
        dependsOn: 'country',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined || value === null) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        },
        tooltip: this.sfcText['tramite-sic-procon']['escriba-departamento'],
      },
      {
        name: 'otroMunicipio',
        label: this.comunText['municipality'],
        placeholder: '',
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS),
          Validators.maxLength(30)
        ],
        errorMessages: {
          required: this.sfcText['tramite-sic-procon']['campo-required'],
          maxlength: this.sfcText['tramite-sic-procon']['campo-maxlength'],
          pattern: this.comunText['municipality-pattern']
        },
        dependsOn: 'country',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined || value === null) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        },
        tooltip: this.sfcText['tramite-sic-procon']['escriba-municipio'],
      },
      {
        name: 'email',
        label: this.comunText['email'],
        type: 'email',
        required: true,
        placeholder: this.comunText['email-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.pattern(Constants.REGEX_CORREO_ELECTRONICO),
          Validators.maxLength(100),
        ],
        errorMessages: {
          required: this.comunText['correo-required'],
          pattern: this.comunText['email-pattern'],
          maxlength: this.comunText['email-maxlength'],
        },
      }
      // {
      //   isSubtitle: true,
      //   subtitleText: this.comunText['subtitulo-representante'],
      //   name: 'subTitle',
      //   label: '',
      //   type: 'text',
      //   visible: true,
      // },
      // {
      //   name: 'representativeFirstName',
      //   label: this.comunText['primer-nombre'],
      //   type: 'text',
      //   required: true,
      //   placeholder: this.comunText['primer-nombre-placeholder'],
      //   width: '6',
      //   visible: true,
      //   validation: [
      //     Validators.minLength(2),
      //     Validators.maxLength(25),
      //     Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
      //   ],
      //   errorMessages: {
      //     required: this.comunText['primer-nombre-required'],
      //     pattern: this.comunText['nombre-pattern'],
      //     minlength: this.comunText['nombre-minlength'],
      //     maxlength: this.comunText['nombre-maxlength'],
      //   },
      // },
      // {
      //   name: 'representativeSecondName',
      //   label: this.comunText['segundo-nombre'],
      //   type: 'text',
      //   required: false,
      //   placeholder: this.comunText['segundo-nombre-placeholder'],
      //   width: '6',
      //   visible: true,
      //   validation: [
      //     Validators.minLength(2),
      //     Validators.maxLength(25),
      //     Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
      //   ],
      //   errorMessages: {
      //     pattern: this.comunText['nombre-pattern'],
      //     minlength: this.comunText['nombre-minlength'],
      //     maxlength: this.comunText['nombre-maxlength'],
      //   },
      // },
      // {
      //   name: 'representativFirstLastName',
      //   label: this.comunText['primer-apellido'],
      //   type: 'text',
      //   required: true,
      //   placeholder: this.comunText['primer-apellido-placeholder'],
      //   width: '6',
      //   visible: true,
      //   validation: [
      //     Validators.minLength(2),
      //     Validators.maxLength(25),
      //     Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
      //   ],
      //   errorMessages: {
      //     required: this.comunText['primer-apellido-required'],
      //     pattern: this.comunText['nombre-pattern'],
      //     minlength: this.comunText['apellido-minlength'],
      //     maxlength: this.comunText['apellido-maxlength'],
      //   },
      // },
      // {
      //   name: 'representativeSecondLastName',
      //   label: this.comunText['segundo-apellido'],
      //   type: 'text',
      //   required: false,
      //   placeholder: this.comunText['segundo-apellido-placeholder'],
      //   width: '6',
      //   visible: true,
      //   validation: [
      //     Validators.minLength(2),
      //     Validators.maxLength(25),
      //     Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
      //   ],
      //   errorMessages: {
      //     pattern: this.comunText['nombre-pattern'],
      //     minlength: this.comunText['apellido-minlength'],
      //     maxlength: this.comunText['apellido-maxlength'],
      //   },
      // },
    ];
  }

  constructor(
    private readonly fb: FormBuilder,
    private readonly configurarCuentaService: ConfigurarCuentasService,
    private readonly alertaModalService: AlertaModalService,
    private readonly translate: TranslateService,
    private readonly listaServices: ListasService,
    private readonly textTransformService: TextTransformService,
    private readonly tramiteService: TramiteService,
  ) {
    this.dataUsuario = JSON.parse(
      sessionStorage.getItem(Constants.USER_INFORMATION_STORAGE)!
    );
    this.formTipoPersona = this.fb.group({
      tipoPersona: ['', Validators.required],
    });
    this.formDemandante = this.fb.group({
    });
  }

  ngOnInit() {
    this.listaServices.getCountryList().subscribe((countries: PaisDto[]) => {
      this.paises = countries;
    });
    combineLatest({
      tramites: this.translate.stream('tramites'),
      comun: this.translate.stream('comun-label'),
      alertas: this.translate.stream('alertas'),
    }).subscribe(({ tramites, comun, alertas }) => {
      // Asignar traducciones a variables
      this.sfcText = tramites;
      this.comunText = comun;
      this.alertaText = alertas;
      // Construir formularios después de cargar traducciones
      this.buildForms();
      this.iniciarColumnas();
    });
    this.getListas();
    sessionStorage.setItem(Constants.PASOS, '1');
  }

  ngOnChanges(changes: SimpleChanges) {
    const tramite: TramiteSuperfinancieraDto =
      changes['tramiteSfc'].currentValue;

    if (tramite != undefined) {
      sessionStorage.setItem(
        'tramiteSfc',
        JSON.stringify(tramite)
      );
      if (tramite?.demandante != undefined) {
        const demandantesSession = JSON.parse(sessionStorage.getItem('demandantes') ?? '[]');
        if (demandantesSession.length === 0) {
          this.demandantes = [];

          for (const demandante of tramite.demandante) {
            const yaExiste = this.demandantes.some(
              dem =>
                dem.idTipoIdentificacion === demandante.idTipoIdentificacion &&
                dem.identificacion === demandante.identificacion
            );

            if (!yaExiste) {
              if (demandante.idTipoPersona == Constants.TIPO_PERSONA.NATURAL) {
                demandante.datosRepresentanteLegal = null;
              }
              this.demandantes.push(demandante);
            }
          }

          sessionStorage.setItem('demandantes', JSON.stringify(this.demandantes));

        } else {
          this.demandantes = [...demandantesSession];

          for (const demandante of tramite.demandante) {

            // Si no existe en sesión → fue eliminado → saltar
            const sigueEnSession = demandantesSession.some(
              (d: any) =>
                d.idTipoIdentificacion === demandante.idTipoIdentificacion &&
                d.identificacion === demandante.identificacion
            );

            if (!sigueEnSession) continue;

            const yaExiste = this.demandantes.some(
              dem =>
                dem.idTipoIdentificacion === demandante.idTipoIdentificacion &&
                dem.identificacion === demandante.identificacion
            );

            if (!yaExiste) {
              if (demandante.idTipoPersona == Constants.TIPO_PERSONA.NATURAL) {
                demandante.datosRepresentanteLegal = null;
              }

              this.demandantes.push(demandante);
              sessionStorage.setItem('demandantes', JSON.stringify(this.demandantes));
            }
          }
        }
        this.dataTableNatural = this.demandantes.filter(d => d.idTipoPersona === 1);
        this.dataTableJuridica = this.demandantes.filter(d => d.idTipoPersona === 2);

        this.iniciarColumnas();
        this.reiniciarFormularios();
      }
    } else {
      this.getUsuario();
    }
  }

  getListas() {
    this.listaServices
      .getListaValor(Constants.LISTAS.SFC_SEXO)
      .subscribe(response => {
        this.listasSexo = response as FormFieldOption[];
        this.setValueLists(this.formFieldsDemandanteNatural, 'sexo', response);
      });
  }

  setValueLists(formField: FormField[], fieldName: string, options: FormFieldOption[]) {
    const field = formField.find(item => item.name == fieldName);
    if (field) {
      field.options = options;
    }
  }

  validarFormularioTipoPersona(formGroup: FormGroup) {
    if (formGroup?.valid) {
      this.formTipoPersona = formGroup;
    }
  }

  validarFormularioDemandante(formGroup: FormGroup) {
    setTimeout(() => {
      this.formDemandante = formGroup;
    }, 100);

    this.tipoDocumento = formGroup?.get('typeOfDocument')?.value;

    const tipo = formGroup?.value['typeOfDocument'];
    const identificacion = formGroup?.value['identificacion'];

    // Si los valores han cambiado, proceder
    const tipoHaCambiado = tipo !== this.prevTipo;
    const identificacionHaCambiado = identificacion !== this.prevIdentificacion;

    if (
      tipo &&
      identificacion &&
      (tipoHaCambiado || identificacionHaCambiado)
    ) {
      this.prevTipo = tipo;
      this.prevIdentificacion = identificacion;
    }
    this.demandanteEmit.emit({
      formTipoPersonaDemandante: this.formTipoPersona,
      formDemandante: this.formDemandante,
    });
    if (formGroup) {
      if (formGroup?.get('country')?.value == Constants.ID_COLOMBIA) {
        formGroup?.controls['departament']?.addValidators(Validators.required);
        formGroup?.controls['municipality']?.addValidators(Validators.required);
        formGroup?.controls['otroDepartamento']?.removeValidators(
          Validators.required
        );
        formGroup?.controls['otroMunicipio']?.removeValidators(
          Validators.required
        );
        formGroup.get('otroMunicipio')?.updateValueAndValidity();
        formGroup.get('otroDepartamento')?.updateValueAndValidity();
      } else {
        formGroup?.controls['departament']?.removeValidators(
          Validators.required
        );
        formGroup?.controls['municipality']?.removeValidators(
          Validators.required
        );
        formGroup?.controls['otroDepartamento']?.addValidators(
          Validators.required
        );
        formGroup?.controls['otroMunicipio']?.addValidators(
          Validators.required
        );
        formGroup.get('otroMunicipio')?.updateValueAndValidity();
        formGroup.get('otroDepartamento')?.updateValueAndValidity();
      }
    }
  }

  onChangeValidarFormulario($event: {
    controlName?: string;
    controlValue: unknown;
    form: FormGroup;
  }) {
    const formGroup = $event.form;
    const idTipoDocumento: number = +formGroup?.get('typeOfDocument')?.value;
    const identificacion: number = +formGroup?.get('identificacion')?.value;
    const numeroDocumentoDemandanteN = this.formFieldsDemandanteNatural.find(
      field => field.name == 'identificacion'
    );
    const numeroDocumentoDemandanteJ = this.formFieldsDemandanteJuridica.find(
      field => field.name == 'identificacion'
    );
    if (
      $event.controlName == 'typeOfDocument' ||
      $event.controlName == 'identificacion'
    ) {
      if (idTipoDocumento !== null && identificacion !== null) {
        if (
          idTipoDocumento == 1 ||
          idTipoDocumento == 2 ||
          idTipoDocumento == 5
        ) {
          if (numeroDocumentoDemandanteN != undefined) {
            formGroup
              .get('identificacion')
              ?.setValidators([
                Validators.required,
                Validators.minLength(4),
                Validators.maxLength(12),
                Validators.pattern(/^\d+$/),
              ]);
            numeroDocumentoDemandanteN.errorMessages!['minlength'] =
              this.comunText['numero-documento-minlength'];
            numeroDocumentoDemandanteN.errorMessages!['maxlength'] =
              this.comunText['numero-documento-maxlength'];
            numeroDocumentoDemandanteN.errorMessages!['pattern'] =
              this.comunText['numero-documento-pattern'];
          }
        } else if (idTipoDocumento == 4) {
          if (numeroDocumentoDemandanteN != undefined) {
            formGroup
              .get('identificacion')
              ?.setValidators([
                Validators.required,
                Validators.minLength(4),
                Validators.maxLength(8),
                Validators.pattern(
                  Constants.REGEX_ALFANUMERICO_VALIDATION_SIN_ESPACIO
                ),
              ]);
            numeroDocumentoDemandanteN.errorMessages!['minlength'] =
              this.comunText['numero-documento-minlength-ce'];
            numeroDocumentoDemandanteN.errorMessages!['maxlength'] =
              this.comunText['numero-documento-maxlength-ce'];
            numeroDocumentoDemandanteN.errorMessages!['pattern'] =
              this.comunText['numero-documento-pattern-ce'];
          }
        } else if (idTipoDocumento == 3) {
          if (numeroDocumentoDemandanteJ != undefined) {
            formGroup
              .get('identificacion')
              ?.setValidators([
                Validators.required,
                Validators.maxLength(9),
                Validators.pattern(/^\d+$/),
              ]);
            numeroDocumentoDemandanteJ.errorMessages!['maxlength'] =
              this.comunText['otro-maxlength'];
            numeroDocumentoDemandanteJ.errorMessages!['pattern'] =
              this.comunText['otro-pattern'];
          }
        }
        formGroup.get('identificacion')?.updateValueAndValidity();
      }
    }

    if ($event.controlName == 'country') {
      const idPais = this.paises.find(
        item => item.Codigo == Constants.CODIGO_COLOMBIA
      )?.Id;
      const idPaisSeleccionado = +formGroup?.get('country')?.value;
      if (idPais === idPaisSeleccionado) {
        formGroup?.controls['departament']?.addValidators(Validators.required);
        formGroup?.controls['municipality']?.addValidators(Validators.required);
        formGroup?.controls['otroDepartamento']?.removeValidators(
          Validators.required
        );
        formGroup?.controls['otroMunicipio']?.removeValidators(
          Validators.required
        );
        formGroup.get('otroMunicipio')?.updateValueAndValidity();
        formGroup.get('otroDepartamento')?.updateValueAndValidity();
      } else {
        let clearInputs: boolean = false
        if (formGroup?.controls['country'].value) {
          this.auxIdCountry.push(formGroup?.controls['country'].value)
          if (this.auxIdCountry.length > 1) {
            clearInputs = formGroup?.controls['country'].value != this.auxIdCountry[this.auxIdCountry.length - 2]
          }
        }
        if (clearInputs) {
          formGroup?.controls['otroDepartamento'].setValue('')
          formGroup?.controls['otroMunicipio'].setValue('')
        }
        formGroup?.controls['departament']?.removeValidators(
          Validators.required
        );
        formGroup?.controls['municipality']?.removeValidators(
          Validators.required
        );
        formGroup?.controls['otroDepartamento']?.addValidators(
          Validators.required
        );
        formGroup?.controls['otroMunicipio']?.addValidators(
          Validators.required
        );
        formGroup?.controls['otroMunicipio']?.markAsDirty();
        formGroup?.controls['otroMunicipio']?.markAllAsTouched();
        formGroup.get('otroMunicipio')?.updateValueAndValidity();
        formGroup.get('otroDepartamento')?.updateValueAndValidity();
        if (+this.formTipoPersona.get('tipoPersona')?.value == 1) {
          this.formFieldsDemandanteNatural.forEach((field: FormField) => {
            if (['otroMunicipio', 'otroDepartamento']
              .includes(field.name)
            ) {
              field.required = true
            }
          });
        } else {
          this.formFieldsDemandanteJuridica.forEach((field: FormField) => {
            if (['otroMunicipio', 'otroDepartamento']
              .includes(field.name)
            ) {
              field.required = true
            }
          });
        }

      }
    }
    this.mostrarCamposRequeridos(formGroup)
  }

  // Agregar demandante
  agregarDemandante(guardarSinEnviar: boolean = false, btnVolver: boolean) {
    const demandante: PersonaDto = {
      id: this.demandanteOriginal?.id,
      idTipoPersona: +this.formTipoPersona.get('tipoPersona')?.value,
      idTipoIdentificacion: this.formDemandante.get('typeOfDocument')?.value,
      identificacion: this.formDemandante.get('identificacion')?.value,
      primerNombre: this.formDemandante.get('primerNombre')?.value,
      segundoNombre: this.formDemandante.get('segundoNombre')?.value,
      primerApellido: this.formDemandante.get('primerApellido')?.value,
      segundoApellido: this.formDemandante.get('segundoApellido')?.value,
      razonSocial: this.formDemandante.get('razonSocial')?.value,
      fechaNacimiento: this.formDemandante.get('fechaNacimiento')?.value,
      telefonoPrincipal: this.formDemandante.get('telefono')?.value,
      correoElectronico: this.formDemandante.get('email')?.value,
      conCondicionEspecial: this.formDemandante.value['conditionEspecial'] === 1,
      enLgbt: this.formDemandante.value['lgtbiq'] === 1,
      direccionPersona: [
        {
          direccionNotificacion: this.formDemandante.get('direccion')?.value,
        },
      ],
      idSexo: this.formDemandante.get('sexo')?.value,
      municipio: {
        id: this.formDemandante.get('municipality')?.value ?? '',
        idDepartamento: this.formDemandante.get('departament')?.value ?? '',
        idPais: this.formDemandante.get('country')?.value ?? ''
      },
      departamentoExtranjero: this.formDemandante.get('otroDepartamento')?.value,
      ciudadExtranjero: this.formDemandante.get('otroMunicipio')?.value,
    };

    const existeDuplicado = (this as any).esDuplicadoDemandante(demandante, this.demandanteOriginal);

    this.demandados = JSON.parse(sessionStorage.getItem('demandados')!);
    this.apoderado = JSON.parse(sessionStorage.getItem('apoderados')!);

    const isEmptyDemandado = this.searchInDemandados(
      demandante.idTipoIdentificacion!,
      +demandante.identificacion!
    );
    const isEmptyApoderado = this.searchInApoderado(
      demandante.idTipoIdentificacion!,
      +demandante.identificacion!
    );

    if (!isEmptyDemandado || !isEmptyApoderado) {
      this.existePersona = true;
      this.alertaModalService.error(
        this.alertaText['error'],
        this.alertaText['sic-comp-desleal-alertas']['existe']
      );
      return;
    }

    if (existeDuplicado) {
      this.existePersona = true;
      this.alertaModalService.error(
        this.alertaText['error'],
        this.alertaText['demandante-ya-agregado']
      );
      return;
    }

    const demandanteSession = JSON.parse(sessionStorage.getItem('demandantes') ?? '[]');
    let indiceExistente = -1;

    if (this.demandanteOriginal) {
      indiceExistente = demandanteSession.findIndex(
        (d: PersonaDto) =>
          d.idTipoIdentificacion === this.demandanteOriginal?.idTipoIdentificacion &&
          d.identificacion === this.demandanteOriginal?.identificacion
      );
    }

    if (indiceExistente !== -1) {
      demandanteSession[indiceExistente] = demandante;
    } else {
      demandanteSession.push(demandante);
    }

    this.demandantes = demandanteSession;
    this.demandanteOriginal = null;
    sessionStorage.setItem('demandantes', JSON.stringify(this.demandantes));
    this.dataTableNatural = this.demandantes.filter(item => item.idTipoPersona === Constants.TIPO_PERSONA.NATURAL);
    this.dataTableJuridica = this.demandantes.filter(item => item.idTipoPersona === Constants.TIPO_PERSONA.JURIDICA);
    this.iniciarColumnas();
    this.reiniciarFormularios();
    if (guardarSinEnviar) {
      if (!btnVolver) {
        this.alertaModalService.exito(
          this.alertaText['agregado'],
          this.alertaText['demandante-agregado']
        );
      }
    }
    this.isEdit = false;
  }




  private esDuplicadoDemandante(demandante: PersonaDto, excluir?: PersonaDto): boolean {
    return this.demandantes.some(d => {
      if (excluir &&
        d.idTipoIdentificacion === excluir.idTipoIdentificacion &&
        d.identificacion === excluir.identificacion) {
        return false;
      }
      return d.idTipoPersona === demandante.idTipoPersona &&
        d.idTipoIdentificacion === demandante.idTipoIdentificacion &&
        d.identificacion === demandante.identificacion;
    });
  }


  searchInDemandados(idTipoDocumento: number, identificacion: number): boolean {
    let isEmpty = true;
    if (this.demandados) {
      this.demandados.forEach(elemento => {
        if (
          elemento.idTipoIdentificacion === idTipoDocumento &&
          +elemento.identificacion! === identificacion
        ) {
          this.alertaModalService.advertencia(
            this.alertaText['tipo-numero-documento-existe-demandado']
          );
          isEmpty = false;
        }
      });
    } else {
      isEmpty = true;
    }
    return isEmpty;
  }

  searchInDemandantes(
    idTipoDocumento: number,
    identificacion: number
  ): boolean {
    let isEmpty = true;
    if (this.demandantes) {
      this.demandantes.forEach(elemento => {
        if (
          elemento.idTipoIdentificacion === idTipoDocumento &&
          +elemento.identificacion! === identificacion
        ) {
          this.alertaModalService.advertencia(
            this.alertaText['tipo-numero-documento-existe-demandante']
          );
          isEmpty = false;
        }
      });
    } else {
      isEmpty = true;
    }
    return isEmpty;
  }

  searchInApoderado(idTipoDocumento: number, identificacion: number): boolean {
    let isEmpty = true;
    if (this.apoderado) {
      this.apoderado.forEach(elemento => {
        if (
          elemento.idTipoIdentificacion === idTipoDocumento &&
          +elemento.identificacion! === identificacion
        ) {
          this.alertaModalService.advertencia(
            this.alertaText['tipo-numero-documento-existe-apoderado']
          );
          isEmpty = false;
        }
      });
    } else {
      isEmpty = true;
    }
    return isEmpty;
  }

  habilitarBoton(): boolean {
    return this.demandantes.length === 0;
  }

  private iniciarColumnas() {
    this.columnsNatural = [
      {
        field: 'primerNombre',
        title: this.comunText['primer-nombre'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
      {
        field: 'primerApellido',
        title: this.comunText['primer-apellido'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
      {
        field: 'identificacion',
        title: this.comunText['numero-documento'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
      {
        field: 'telefonoPrincipal',
        title: this.comunText['telefono'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
    ];

    this.columnsJuridica = [
      {
        field: 'razonSocial',
        title: this.comunText['razon-social'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
      {
        field: 'identificacion',
        title: this.comunText['numero-documento'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
      {
        field: 'telefonoPrincipal',
        title: this.comunText['telefono'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
    ];

    this.actions = [
      {
        type: 'button',
        title: '',
        icon: 'pencil-square-o',
        idAccion: '2',
      },
      {
        type: 'button',
        title: '',
        icon: 'trash-o',
        idAccion: '1',
      },
    ];
  }

  // Acciones demandante

  accionesDemandante(event: any) {
    const persona = event.item as PersonaDto;

    if (event.idAccion == '2') { // editar
      this.setearDatosDemandante(persona);

      this.demandanteOriginal = { ...persona };

    } else if (event.idAccion == '1') { // eliminar
      this.alertaModalService.confirmacion(
        this.alertaText['sic-procon-alertas']['eliminar-registro'],
        '',
        () => {
          this.demandanteOriginal = null;
          this.demandantes = this.demandantes.filter(item => item !== persona);
          this.dataTableNatural = this.demandantes.filter(
            item => item.idTipoPersona === 1
          );
          this.dataTableJuridica = this.demandantes.filter(
            item => item.idTipoPersona === 2
          );
          sessionStorage.setItem('demandantes', JSON.stringify(this.demandantes));
          this.iniciarColumnas();
        },
        () => { }
      );
    }
  }
  setearDatosDemandante(persona: PersonaDto) {
    this.formTipoPersona.patchValue({
      tipoPersona: `${persona.idTipoPersona ?? 1}`,
    });
    this.formFieldsTipoPersona = this.formFieldsTipoPersona.map(field => {
      switch (field.name) {
        case 'tipoPersona':
          field.value = persona.idTipoPersona?.toString() ?? '1';
          break;
      }
      return field;
    });
    this.isEdit = true;
    const esExtranjero = this.esExtranjero(persona);
    if (persona.idTipoPersona === +Constants.TYPE_OF_PERSON_NATURAL) {
      setTimeout(() => {
        this.formFieldsDemandanteNatural = this.formFieldsDemandanteNatural.map(field => {
          switch (field.name) {
            case 'typeOfDocument':
              field.value = persona.idTipoIdentificacion;
              break;
            case 'identificacion':
              field.value = persona.identificacion;
              break;
            case 'primerNombre':
              field.value = persona.primerNombre;
              break;
            case 'segundoNombre':
              field.value = persona.segundoNombre;
              break;
            case 'primerApellido':
              field.value = persona.primerApellido;
              break;
            case 'segundoApellido':
              field.value = persona.segundoApellido;
              break;
            case 'fechaNacimiento':
              if (persona.fechaNacimiento) {
                field.value = persona.fechaNacimiento
                  ? this.normalizeDate(persona.fechaNacimiento)
                  : '';
              } else {
                field.value = undefined;
              }
              break;
            case 'telefono':
              field.value = persona.telefonoPrincipal;
              break;
            case 'email':
              field.value = persona.correoElectronico;
              break;
            case 'country':
              field.value = persona.municipio?.idPais;
              break;
            case 'departament':
              field.value = esExtranjero ? undefined : persona.municipio?.idDepartamento;
              break;
            case 'municipality':
              field.value = esExtranjero ? undefined : persona.municipio?.id;
              break;
            case 'otroDepartamento':
              field.value = esExtranjero ? this.obtenerDepartamento(persona) : undefined;
              break;
            case 'otroMunicipio':
              field.value = esExtranjero ? this.obtenerMunicipio(persona) : undefined;
              break;
            case 'direccion':
              field.value = persona.direccionPersona?.[0]?.direccionNotificacion;
              break;
            case 'sexo':
              field.value = persona.idSexo;
              break;
            case 'lgtbiq':
              field.value = persona.enLgbt ? 1 : 2;
              break;
            case 'conditionEspecial':
              field.value = persona.conCondicionEspecial ? 1 : 2;
              break;

          }
          return field;
        });
      }, 800);
    } else {
      setTimeout(() => {
        this.formFieldsDemandanteJuridica = this.formFieldsDemandanteJuridica.map(field => {
          switch (field.name) {
            case 'typeOfDocument':
              field.value = persona.idTipoIdentificacion;
              break;
            case 'identificacion':
              field.value = persona.identificacion;
              break;
            case 'razonSocial':
              field.value = persona.razonSocial;
              break;
            case 'direccion':
              field.value = persona.direccionPersona?.[0]?.direccionNotificacion;
              break;
            case 'telefono':
              field.value = persona.telefonoPrincipal;
              break;
            case 'country':
              field.value = persona.municipio?.idPais;
              break;
            case 'departament':
              field.value = esExtranjero ? undefined : persona.municipio?.idDepartamento;
              break;
            case 'municipality':
              field.value = esExtranjero ? undefined : persona.municipio?.id;
              break;
            case 'otroDepartamento':
              field.value = esExtranjero ? this.obtenerDepartamento(persona) : undefined;
              break;
            case 'otroMunicipio':
              field.value = esExtranjero ? this.obtenerMunicipio(persona) : undefined;
              break;
            case 'email':
              field.value = persona.correoElectronico;
              break;
            // case 'representativeFirstName':
            //   field.value = persona.datosRepresentanteLegal?.primerNombre;
            //   break;
            // case 'representativeSecondName':
            //   field.value = persona.datosRepresentanteLegal?.segundoNombre;
            //   break;
            // case 'representativFirstLastName':
            //   field.value = persona.datosRepresentanteLegal?.primerApellido;
            //   break;
            // case 'representativeSecondLastName':
            //   field.value = persona.datosRepresentanteLegal?.segundoApellido;
            //   break;
          }
          return field;
        });
      }, 800)
    }
  }

  private esExtranjero(persona: PersonaDto): boolean {
    return persona?.municipio?.idPais !== Constants.ID_COLOMBIA;
  }

  private obtenerDepartamento(persona: PersonaDto): string | undefined {
    return persona.otroDepartamento && persona.otroDepartamento.trim() !== ''
      ? persona.otroDepartamento
      : persona.departamentoExtranjero || undefined;
  }

  private obtenerMunicipio(persona: PersonaDto): string | undefined {
    return persona.otroMunicipio && persona.otroMunicipio.trim() !== ''
      ? persona.otroMunicipio
      : persona.ciudadExtranjero || undefined;
  }

  private normalizeDate(date: any): string {
    if (!date) return '';

    // Caso 1: ya viene con formato yyyy-MM-dd
    if (typeof date === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(date)) {
      return date;
    }

    // Caso 2: viene como ISO o como Date
    const d = new Date(date);
    if (isNaN(d.getTime())) return '';

    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${d.getFullYear()}-${month}-${day}`;
  }

  reiniciarFormularios() {
    if (!this.existePersona) {
      this.mostrarFormulario = false;
      setTimeout(() => {
        this.formDemandante.reset();
        this.formTipoPersona.reset();
        this.mostrarFormulario = true;

        this.formFieldsTipoPersona = this.formFieldsTipoPersona.map(field => {
          field.value = undefined;
          field.disabled = false;
          return field;
        });

        this.formFieldsDemandanteNatural = this.formFieldsDemandanteNatural.map(
          field => {
            if (['conditionEspecial', 'lgtbiq'].includes(field.name)) {
              field.value = 2;
            } else {
              field.value = undefined;
            }
            field.disabled = false;
            return field;
          }
        );

        this.formFieldsDemandanteJuridica = this.formFieldsDemandanteJuridica.map(
          field => {
            field.value = undefined;
            field.disabled = false;
            return field;
          }
        );

      }, 0);
    } else {
      this.formDemandante.get('identificacion')?.setErrors({ incorrect: true });
    }
  }

  cancelarEditarDemandante() {
    this.indexEditarDemandante = undefined;
    this.formDemandante.reset();
    this.formTipoPersona.reset();
  }

  onClickSiguiente(e: Event, guardarSinEnviar: boolean) {
    if (!this.validarDemandantes()) {
      this.formTipoPersona.markAllAsTouched();
      this.formDemandante.markAllAsTouched();
      this.alertaModalService.error(
        this.alertaText['error'],
        this.alertaText['form_invalid']
      );
      return;
    }
    this.seguirConApoderado(e, guardarSinEnviar);
  }

  seguirConApoderado(e: Event, guardarSinEnviar: boolean) {
    if (!guardarSinEnviar) {
      if (this.formTipoPersona.valid && !this.formDemandante.valid) {
        this.formTipoPersona.markAllAsTouched();
        this.formDemandante.markAllAsTouched();
        this.alertaModalService.error(
          this.alertaText['error'],
          this.alertaText['form_invalid']
        );
        return;
      }
    }
    if (this.formTipoPersona.valid) {
      this.agregarDemandante(guardarSinEnviar, false);
    } else {
      this.demandantes = JSON.parse(sessionStorage.getItem('demandantes') ?? '[]');

      if (this.demandantes.length > 0) {
        this.demandantes.forEach(demandante => {
          if (!demandante.id) {
            const aux = this.demandantes.find(d => d.identificacion === demandante.identificacion);
            if (aux) demandante.id = aux.id;
          }
        });
      }
    }

    const tramite: TramiteSuperfinancieraDto = {
      id: this.tramiteSfc ? this.tramiteSfc.id : null,
      idTipoTramite: Constants.TRAMITES.SUPER_FINANCIERA,
      esParcial: true,
      enviar: false,
      demandante: this.demandantes,
      usuario: {
        id: this.dataUsuario.idUsuario,
      },
      paso: 1,
    };

    if (!guardarSinEnviar) {
      let paso = +JSON.parse(sessionStorage.getItem(Constants.PASOS)!);
      if (paso && !guardarSinEnviar) {
        sessionStorage.setItem(Constants.PASOS, JSON.stringify(2));
      }
      this.continuar.emit({
        tramite: tramite,
        formValid: this.habilitarBoton(),
        event: e,
      });
    } else {
      this.guardarSinEnviar.emit({
        tramite: tramite,
        formValid: this.habilitarBoton(),
        event: e,
      });
    }
  }

  getUsuario() {
    const user_type = JSON.parse(
      sessionStorage.getItem(Constants.USER_TYPE) ?? '{}');
    if (user_type.Nombre !== 'Abogado') {
      this.configurarCuentaService
        .getDataPersonal(this.dataUsuario.idUsuario!)
        .subscribe((response: any) => {
          this.formTipoPersona.patchValue({
            tipoPersona: `${response.data.Id_Tipo_Persona}`,
          });

          this.formFieldsTipoPersona = this.formFieldsTipoPersona.map(field => {
            if (field.name === 'tipoPersona') {
              field.value = `${response.data.Id_Tipo_Persona}`;
            }
            return field;
          });
          this.dataUsuario = this.textTransformService.transformarAMayusculas(
            this.dataUsuario
          );
          if (response.data.Id_Tipo_Persona === 1) {
            const personaNatural: PersonaDto = {
              primerNombre: this.dataUsuario.primerNombre,
              segundoNombre: this.dataUsuario.segundoNombre,
              primerApellido: this.dataUsuario.primerApellido,
              segundoApellido: this.dataUsuario.segundoApellido,
              typeOfDocument: response.data.Id_Tipo_Identificacion,
              identificacion: this.dataUsuario.identificacion?.toString(),
              email: this.dataUsuario.correoElectronico,
              country: this.dataUsuario.pais,
              departament: this.dataUsuario.departamento,
              municipality: +this.dataUsuario.municipio,
              direccion: [
                {
                  direccionNotificacion:
                    this.dataUsuario?.direccion?.find(
                      (elemento: {
                        Direccion_Notificacion?: string;
                        Es_Primaria?: boolean;
                        Id?: number
                      }) => elemento.Es_Primaria
                    )?.Direccion_Notificacion ??
                    this.dataUsuario?.direccion?.[0]?.Direccion_Notificacion ?? '',
                },
              ],
              fechaNacimiento: this.setDateValue(this.dataUsuario.fechaNacimiento?.toString()!),
              telefono: this.dataUsuario.telefonoPrincipal,
              otroDepartamento: response.data.Otro_Departamento ?? undefined,
              otroMunicipio: response.data.Otro_Municipio ?? undefined,
            };
            setTimeout(() => {
              this.formFieldsDemandanteNatural = this.formFieldsDemandanteNatural.map(field => {
                const value = personaNatural[field.name as keyof typeof personaNatural];

                if (value !== undefined && value !== null) {
                  // Transformar arrays u objetos en string si es necesario
                  if (Array.isArray(value)) {

                    if (field.name === 'direccion') {
                      field.value = value[0]?.direccionNotificacion ?? '';
                    }
                  } else if (typeof value === 'object') {
                    field.value = JSON.stringify(value);
                  } else {
                    field.value = value;

                  }
                }

                return field;
              });
            }, 500);

          } else {
            const personaJuridica: PersonaDto = {
              typeOfDocument: response.data.Id_Tipo_Identificacion,
              identificacion: this.dataUsuario?.identificacion!.toString(),
              razonSocial: this.dataUsuario.razonSocial,
              direccion: [
                {
                  direccionNotificacion:
                    this.dataUsuario?.direccion?.find(
                      (elemento: {
                        Direccion_Notificacion?: string;
                        Es_Primaria?: boolean;
                        Id?: number
                      }) => elemento.Es_Primaria
                    )?.Direccion_Notificacion ??
                    this.dataUsuario?.direccion?.[0]?.Direccion_Notificacion ?? '',
                },
              ],
              telefono: this.dataUsuario.telefonoPrincipal,
              email: this.dataUsuario.correoElectronico,
              country: this.dataUsuario.pais,
              departament: this.dataUsuario.departamento,
              municipality: +this.dataUsuario.municipio,
              otroDepartamento: response.data.Otro_Departamento ?? undefined,
              otroMunicipio: response.data.Otro_Municipio ?? undefined,
            };

            setTimeout(() => {
              this.formFieldsDemandanteJuridica = this.formFieldsDemandanteJuridica.map(field => {
                const value = personaJuridica[field.name as keyof typeof personaJuridica];

                if (value !== undefined && value !== null) {
                  // Transformar arrays u objetos en string si es necesario
                  if (Array.isArray(value)) {

                    if (field.name === 'direccion') {
                      field.value = value[0]?.direccionNotificacion ?? '';
                    }
                  } else if (typeof value === 'object') {
                    field.value = JSON.stringify(value);
                  } else {
                    field.value = value;
                  }
                }

                return field;
              });
            }, 500);
          }


        });
    }
  }

  setDateValue(dateString: string): string | undefined {
    if (!dateString) return; // Manejo de caso nulo o vacío
    const date = new Date(dateString);
    const formattedDate = date.toISOString().split('T')[0]; // Formato yyyy-MM-dd
    return formattedDate;
  }

  renombarArchivo(archivo: File, nuevoNombre: string): File {
    return new File([archivo], nuevoNombre, {
      type: archivo.type,
      lastModified: archivo.lastModified,
    });
  }

  mostrarCamposRequeridos(formGroup: FormGroup) {
    if (formGroup) {
      const camposRequeridos = Object.keys(formGroup.controls).filter(
        controlName =>
          formGroup.get(controlName)?.hasValidator(Validators.required)
      );
      // console.log(camposRequeridos);

    }
  }
  validarDemandantes(): boolean {

    return this.demandantes.every((d) => {

      const esNatural = d.idTipoPersona === Constants.TIPO_PERSONA.NATURAL;
      const esJuridica = d.idTipoPersona === Constants.TIPO_PERSONA.JURIDICA;

      const esExtranjero = d.municipio?.idPais != Constants.ID_COLOMBIA;
      if (!d.municipio?.idPais || isNaN(+d.municipio.idPais)) {
        return false;
      }
      let validacionUbicacion = false;

      if (esExtranjero) {
        const departamento = this.obtenerDepartamento(d);
        const municipio = this.obtenerMunicipio(d);
        validacionUbicacion = !!departamento && !!municipio;
      } else {
        validacionUbicacion =
          !!d.municipio?.idDepartamento && !!d.municipio?.id;
      }

      if (!d.idTipoIdentificacion) return false;
      if (!d.identificacion) return false;

      const patternIdentificacion = this.getPatternIdentificacion(d.idTipoIdentificacion);
      if (!patternIdentificacion.test(d.identificacion)) {
        return false;
      }

      if (
        !d.telefonoPrincipal ||
        !(new RegExp(Constants.REGEX_TELEFONO)).test(d.telefonoPrincipal)
      ) {
        return false;
      }

      if (
        !d.correoElectronico ||
        !(new RegExp(Constants.REGEX_CORREO_ELECTRONICO)).test(d.correoElectronico)
      ) {
        return false;
      }

      if (!d.direccionPersona?.[0]?.direccionNotificacion) {
        return false;
      }

      if (esNatural) {
        const regexNombre = new RegExp(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT);

        if (!d.primerNombre || !regexNombre.test(d.primerNombre)) return false;
        if (d.segundoNombre && !regexNombre.test(d.segundoNombre)) return false;
        if (!d.primerApellido || !regexNombre.test(d.primerApellido)) return false;
        if (d.segundoApellido && !regexNombre.test(d.segundoApellido)) return false;

        if (!validacionUbicacion) return false;

        return true;
      }

      if (esJuridica) {
        const regexRazonSocial = new RegExp(Constants.REGEX_ALPHANUMERIC_RAZON_SOCIAL);

        if (!d.razonSocial || !regexRazonSocial.test(d.razonSocial)) return false;

        if (!validacionUbicacion) return false;

        return true;
      }

      return false;
    });
  }

  getPatternIdentificacion(tipoDocumentoId: number): RegExp {
    switch (tipoDocumentoId) {
      case 1:
      case 2:
      case 5:
        return /^\d{4,12}$/;
      case 4:
        return /^[a-zA-Z0-9]{4,8}$/;
      case 3:
        return /^\d+$/;
      default:
        return /.*/;
    }
  }

}
